/** 算力余额展示：最多两位小数，去掉无意义的 .00 / 尾零 */
export function formatPoint(value) {
  const n = Number(value || 0);
  return n.toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
}

/** 流水中的服务器时长（天）：整数展示 */
export function formatBalanceRecordDays(value) {
  return String(Math.round(Number(value || 0)));
}
